export default __webpack_public_path__ + "static/media/webshield.57345fa7.png";